module.exports = __webpack_public_path__ + "static/media/square_rounded.c6c2f3dc.png";